import { rem } from "polished";
import styled from "styled-components";

import { Button } from "@/components/button";
import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { Typography } from "@/components/editor/shared/typography";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import {
  ColorLabels,
  useInvertedColor,
} from "@/components/editor/utils/use-color";

export const PositionedWrapper = styled.div`
  position: relative;

  .background-squiggle {
    position: absolute;
    bottom: -110px;
    right: 0;
  }
`;

export const ScheduleDescriptionWrapper = withViewportStyle("div")`
  margin-bottom: ${rem(24)};

  ${(props) =>
    props.$viewport.mobile`
    margin-bottom: ${rem(8)};
    `}
`;

export const StyledButton = styled(Button)`
  width: 100%;
  font-weight: 600;
  font-size: ${rem(12)};
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  border-radius: ${rem(200)};
  border: none;
  background-color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY]};
  justify-content: center;

  &:hover {
    border: none;
    background-color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY]};
  }
`;

export const Wrapper = withViewportStyle(BlockPaddingWrapper)`
    ${(props) => props.$viewport.mobile`
      padding: ${rem(80)} ${rem(16)};
    `}
`;

export const FilterWrapper = withViewportStyle("div")`
  .filter-menu {
    position: relative;
    margin-right: ${rem(16)};

    ${(props) => props.$viewport.mobile`
      margin: 0;
    `}
  }
`;

export const ScheduleListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: ${rem(17)};
  }
`;

export const ScheduleDisplayItemWrapper = withViewportStyle("div")`
  --borderColor: ${({ theme }) =>
    useInvertedColor(theme.colors[ColorLabels.BACKGROUND]) === "#000000"
      ? "#1B1F29"
      : theme.colors[ColorLabels.BACKGROUND]};

  display: grid;
  grid-template-columns: 1fr 0.5fr;
  border-radius: ${rem(20)};
  border: ${rem(2)} solid var(--borderColor);

  ${(props) =>
    props.$viewport.mobile`
    grid-template-columns: 1fr;
    padding: ${rem(24)};
    background-color: rgba(255,255,255,.1);
  `}
`;

export const ScheduleDisplayItemContent = withViewportStyle("div")`
  background-color: rgba(255,255,255,.1);
  border-top-left-radius: ${rem(18)};
  border-bottom-left-radius: ${rem(18)};
  padding: ${rem(32)} ${rem(24)} ${rem(36)} ${rem(32)};

  ${(props) => props.$viewport.mobile`
    border-top-right-radius: ${rem(18)};
    border-bottom-left-radius: ${rem(0)};
    padding: 0;
    background: none;
  `}
`;

export const ScheduleDisplayItemDate = withViewportStyle("div")`
  background-color: ${({ theme }) => theme.colors[ColorLabels.VISUALS]};
  padding: ${rem(32)} ${rem(24)} ${rem(36)};
  border-bottom-right-radius: ${rem(18)};
  border-top-right-radius: ${rem(18)};
  
  ${(props) =>
    props.$viewport.mobile`
    border-top-right-radius: 0;
    padding: 0;
    background-color: transparent;
  `}
`;

export const StyledSegmentText = styled(Typography).attrs({
  pattern: "labelOne",
})`
  margin-bottom: ${rem(8)};
  font-weight: 600;
`;

export const StyledScheduleTime = styled(Typography).attrs({
  pattern: "labelOne",
})`
  font-weight: 600;
`;

export const StyledMenuContent = withViewportStyle("div")<{
  $editing: boolean;
  $rounded?: boolean;
  $withBorder?: boolean;
}>`
  position: absolute;
  top: 100%;
  right: 0;
  min-width: ${rem(225)};
  background-color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  box-shadow: 0 ${rem(5)} ${rem(20)} rgba(0, 0, 0, 0.33);
  padding: ${rem(24)};
  margin-top: ${rem(8)};
  border-radius: ${({ $rounded }) => ($rounded ? rem(16) : 0)};
  border: ${({ theme, $withBorder }) =>
    $withBorder
      ? `${rem(2)} solid ${theme.colors[ColorLabels.PRIMARY_FONT]}`
      : "none"};
  -webkit-tap-highlight-color: transparent;
  z-index: var(--z-index-highest);

  ${(props) => props.$viewport.mobile`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: var(--z-index-highest);
    margin-top: unset;

    ${
      props.$editing &&
      `
      max-width: ${rem(364)};
      left: ${rem(48)};
      `
    }
  `}
`;
